
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Title1',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    }
  },
  setup() {
  },
})
